const driverShifts = {
  driverShifts: 'Turnos do motorista',

  driverLink: 'URL do Aplicativo de Agenda do Motorista',

  filters: {
    areas: 'Zonas',
    drivers: 'Motoristas',
    suppliers: 'Fornecedores',
    vehicles: 'Veículos',
    locations: 'Localizações',
    airportLocations: 'Localizações de Aeroporto',
    attributes: 'Atributos', 
  },

  calendarTypes: {
    daily: 'Diário',
    weekly: 'Semanal',
    monthly: 'Mensal',
  },

  driverfilter: {
    all: 'Todos os Motoristas',
    withShift: 'Motoristas com Turnos',
    withoutShifts: 'Motoristas Sem Turnos',
  },

  header: {
    create: 'Criar',
    createMulti: 'Criar Múltiplo',
    switchButton: {
      label: 'Visualizar',
      table: 'Tabela',
      calendar: 'Calendário',
    },
  },

  moreActions: {
    delete: 'Remover',
  },
  toast: {
    error: {
      sameDate: 'A Data de Início e a Data de Término não podem ser idênticas',
      badResponse: 'resposta inválida do servidor [turno de motorista]',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
    },
  },
  headerButtons: {
    createBtn: 'Criar',
    createMultiBtn: 'Crie Turnos Múltiplos',
    deleteBtn: 'Remover',
  },

  table: {
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
    headers: {
      name: 'Motorista',
      email: 'Motorista',
      address: 'Endereço',
      firstTripDistance: 'Distância máxima da 1ª Viagem',
      addrLon: 'Long',
      addrLat: 'Lat',
      at: 'Criado em',
      by: 'Criado por',
      areas: 'Zonas',
      locations: 'Localizações',
      attributes: 'Atributos',
    },
    cells: {
      name: {
        vehicle: 'Veículo',
      },
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  create: {
    successToast: {
      message: 'Turno de motorista criado!',
    },
    errorToast: {
      message: 'Ocorreu um erro! Não foi possível criar um turno do motorista',
    },

    multi: {
      successToast: {
        message: 'Motoristas de sucesso Turnos Criados!',
      },
      errorToast: {
        message: 'Erro! Selecione um dia da semana válido para o turno do motorista',
      },
    },
    modalAfter24: {
      header: 'Aviso',
      body: 'Turnos que já ultrapassam 24 horas não podem ser modificados',
    },
    modalBefore24: {
      header: 'Aviso',
      body: 'As alterações feitas dentro de 24 horas de um turno existente requerem validação. Por favor, confirme para continuar',
    },
  },

  update: {
    successToast: {
      message: 'Mudança de motorista bem-sucedida atualizada!',
    },
    errorToast: {
      message: 'Ocorreu um erro! Não foi possível atualizar o turno do motorista',
    },
  },

  delete: {
    modalError: {
      header: 'Ocorreu um Erro',
      body: 'Não foi possível atualizar',
    },
    modalSuccess: {
      header: 'Sucesso',
      body: ' - Turnos excluídos com sucesso',
    },
  },

  modalRemoveConfirm: {
    header: 'Aviso!',
    bodySingle: 'Você tem certeza que deseja excluir este turno?',
    bodyMultiple: 'Você tem certeza que deseja excluir estes turnos?',
    confirmBtn: 'Remover',
  },

  modalRemoveSingelConfirm: {
    header: 'Excluir o turno do motorista',
    body: 'Você está prestes a excluir 1 turno de motorista',
  },

  form: {
    header: {
      createDriverShift: {
        title: 'Criar',
      },

      createMultipleDriverShift: {
        title: 'Criar Múltiplo',
      },

      updateDriverShift: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
        delete: 'Remover',
      },
    },

    information: {
      details: {
        header: 'Detalhes do motorista',
        fields: {
          driver: 'Motorista',
          vehicle: 'Veículo: {{currentVehicle}}',
        },
      },
      shiftDetails: {
        header: 'Detalhes do Turno',
        overnightShiftNote: 'Observação: Este é um turno noturno',
        fields: {
          fromDate: 'Início',
          toDate: 'Fim',
          address: 'Endereço',
          firstTripDistance: 'Distância máxima da 1ª Viagem',
          attributes: 'Atributos',
          areas: 'Zonas',
          areasPriorityMode: {
            title: 'Modo',
            options: {
              allStops: 'Todas as Paradas',
              firstPickDrop: 'Primeiro Embarque / Última Entrega',
              legAOrigin: 'Origem do Trecho A'
            },
          },
          areasPriorityLevel: {
            title: 'Prioridade',
            options: {
              low: 'Baixo',
              medium: 'Médio',
              high: 'Alto',
              strict: 'Rígido',
            },
          },
          suppliers: 'Fornecedores',
          allowSharedRides: 'Permitir viagens compartilhadas',
        },
      },
      locationsSettings: {
        header: 'Configurações de Localizações',
        fields: {
          locations: 'Localizações',
          enableInBetweenRides: 'Ativar Corridas Intermediárias',
        },
      },
    },
    validations: {
      drivers: {
        required: 'Motoristas é necessário',
        drivers: '',
      },
      driver: {
        required: 'Requer-se motorista',
        driver: '',
      },
      start: {
        required: 'O início é requerido',
        start: '',
      },
      end: {
        required: 'O fim é requerido',
        differentTimes: 'Os horários de início e término de um turno devem ser diferentes.',
        end: '',
      },
    },
    select: 'Selecione',
    buttons: {
      addBreak: '+ Add Break',
    },
  },

  formMulti: {
    header: {
      createMultiDriverShift: {
        title: 'Novos turnos de múltiplos motoristas',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'ADICIONAR CAMINHAMENTOS DE Múltiplos motoristas',
      },
    },

    information: {
      details: {
        header: 'Detalhes do motorista',
        fields: {
          drivers: 'Motoristas',
        },
      },
      shiftDetails: {
        header: 'Detalhes do Turno',
        fields: {
          fromDate: 'A partir da Data',
          toDate: 'Até à data',
          weeksDays: 'Dias da Semana',
          fromHour: 'De hora em hora',
          tohour: 'Para a hora',
          breakStart: 'Início do intervalo',
          breakEnd: 'Fim de intervalo',
        },
      },
    },
    validations: {
      drivers: {
        required: 'Motoristas é necessário',
      },
      driver: {
        required: 'Requer-se motorista',
      },
      start: {
        required: 'O início é requerido',
      },
      end: {
        required: 'O fim é requerido',
      },
    },
    select: 'Selecione',
  },

  totalDriverShifts: 'Total de Turnos do Motorista',

  calendarTable: {
    filters: {
      areas: 'Zonas',
      drivers: 'Motoristas',
      suppliers: 'Fornecedores',
      attributes: 'Atributos', 
    },

    daily: {
      actions: {
        delete: 'Remover',
      },
      noResults: 'Não há resultados',
      noResultsSubHeader: 'Não conseguimos encontrar nenhum item que corresponda à sua pesquisa',
      selectAll: 'Selecionar Tudo',
      selectAllPages: 'Todos os {{limit}} itens nesta página estão selecionados. ',
      btnSelectAllResults: ' Selecionar todos os {{totalDrivers}} itens',
      btnunselectAllResults: 'Limpar seleção',
      totalDrivers: 'Total de Motoristas: {{total}}',
      totalShifts: 'Total de Turnos: {{total}}',
    },
    weekly: {
      actions: {
        delete: 'Remover',
      },
    },
    emptyCell: {
      dayOff: 'Dia de folga',
    },
    headers: {
      driverName: 'Nome',
      monday: 'Segunda-feira {{day}}',
      tuesday: 'Terça-feira {{day}}',
      wednesday: 'Quarta-feira {{day}}',
      thursday: 'Quinta-feira {{day}}',
      friday: 'Sexta-feira {{day}}',
      saturday: 'Sábado {{day}}',
      sunday: 'Domingo {{day}}',
    },
  },
};

export default driverShifts;
